import axios from "axios";

const instance = axios.create({
  // baseURL: "https://localhost:44338/",
   baseURL:'/API/',
  // baseURL:'https://danacommittee.com/API/',
  url: "https://danacommittee.com/DanaImages//",
});

export default instance;

